import React from 'react';
import {withRouter} from "react-router-dom";
import clsx from "clsx";
import { connect } from 'react-redux'
 
import useStyles from './styles';
import { withEuroOrDash } from '../../../../../../utils/utils';
import {buildCurrentCustomerOtherAssetsCategoryPath} from "../../../../../../routes";


const mapStateToProps = (state) => ({
  investmentPlatform: state.get('investmentPlatform').toJS()
});


const CategoryItem = (props) => {
  const classes = useStyles();
  const {
    title,
    totalAmount,
    icon,
    url,
    read_only,
    setActiveCategory
  } = props;

  const handleOpenCategory = () => {
    if (read_only) {
      return null;
    }

    if (setActiveCategory) {
      setActiveCategory();
      return;
    }

    return props.history.push(buildCurrentCustomerOtherAssetsCategoryPath(url));
  };

  return (
    <div className={clsx(classes.categoryItemContainer, read_only && classes.readOnly)} onClick={handleOpenCategory}>
      <p className={classes.categoryItemTitle}>{ title }</p>
      <p className={classes.categoryItemTotalAmount}>{ withEuroOrDash(totalAmount) }</p>
      <img src={icon} className={classes.categoryItemIcon} alt=''/>
    </div>
  );
};

export default connect(mapStateToProps)(withRouter(CategoryItem));